import React from 'react';
import { SubscriberAddOnMethod } from 'types/electionService';
import { AccountCircle, AddCircle, InfoButtonFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { TagWrapperStyled } from './styles';
import { EMPLOYEE_ADDED_METHOD_TAG_TEST_IDS } from '../constants';

interface Props {
  source: SubscriberAddOnMethod;
}

const STATUS_TEXT_MAP = Object.freeze({
  [SubscriberAddOnMethod.CENSUS]: 'Census',
  [SubscriberAddOnMethod.FORM]: 'Form',
  [SubscriberAddOnMethod.LINK]: 'Link',
});

const STATUS_ICON_MAP = Object.freeze({
  [SubscriberAddOnMethod.CENSUS]: (
    <AddCircle color={colors.orange[600]} width="2.2rem" data-test-id={EMPLOYEE_ADDED_METHOD_TAG_TEST_IDS.ADD_CIRCLE} />
  ),
  [SubscriberAddOnMethod.FORM]: (
    <InfoButtonFilled
      color={colors.blue[600]}
      width="2.2rem"
      data-test-id={EMPLOYEE_ADDED_METHOD_TAG_TEST_IDS.INFO_BUTTON_FILLED}
    />
  ),
  [SubscriberAddOnMethod.LINK]: (
    <AccountCircle
      color={colors.green[600]}
      width="2.2rem"
      data-test-id={EMPLOYEE_ADDED_METHOD_TAG_TEST_IDS.ACCOUNT_CIRCLE}
    />
  ),
});

const EmployeeAddedMethodTag: React.FC<Props> = ({ source }) => {
  return (
    <TagWrapperStyled>
      {STATUS_ICON_MAP[source]}
      {STATUS_TEXT_MAP[source]}
    </TagWrapperStyled>
  );
};

export default EmployeeAddedMethodTag;
